import React from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../utils";

export const BlockTry = (props) => {
  const { aside = null } = props;
  const { t } = useTranslation();
  return (
    <section>
      <div className="advance-try">
        <div className="advance-try-bg">
          <img
            src={"//files.authing.co/authing-website/tryblock-bg-img.png"}
            alt="authing advance"
          />
        </div>
        <div className="inner">
          <div>
            <div className="content-warp">
              <div className="slogin">{t("common.common-try-slogin")}</div>
              <div style={{ display: "flex" }}>
                {aside}
                <div className="button-warp" onClick={tryNow}>
                  <Button>{t("common.common-button-立即试用")}</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
